import React, { useState, useContext, useEffect } from 'react'
import { Container, Card, Button, Row, Col } from 'react-bootstrap'
import Flickity from 'react-flickity-component'
import { LinkContainer } from 'react-router-bootstrap'
import { FirebaseContext } from '../firebase'

function Profile(props) {
    const [sequences, setSequences] = useState([])
    const { fire, user } = useContext(FirebaseContext)

    useEffect(() => {
        if (user) {
            getUserSequences()
        }
    }, [user])

    function getUserSequences() {
        fire.firestore().collection('sequences').where("createdBy", "==", user.uid).onSnapshot(handleSnapshot)
    }

    function handleSnapshot(snapshot) {
        setSequences(snapshot.docs.map(doc => {
            return {
                id: doc.id,
                ...doc.data()
            }
        }))
    }

    const sequenceCards = sequences.map(record => {
        return (
            <LinkContainer to={`/edit/${record.id}`} key={record.id}>
                <Card className={"mr-3 mb-3 sequence-card"}>
                    {record.img && <Card.Img variant="top" src={record.img} />}
                    <Card.Body>
                        <Card.Title>{record.name ? record.name : null}</Card.Title>
                        {/* <Card.Text>{record.description ? record.description : null}</Card.Text> */}
                        <Button variant="light">Edit</Button>
                    </Card.Body>
                </Card>
            </LinkContainer>
        )
    })

    return (
        <Container className="mt-3">
            <Row>
                <Col>
                    <div className={"mb-4"}>
                        <h5>Your Sequences</h5>
                        <div className="flex-wrap d-none d-sm-flex">
                            {sequenceCards}
                        </div>
                        <Flickity className="d-block d-sm-none" options={{ wrapAround: false, prevNextButtons: false, cellAlign: "left", pageDots: false }}>
                            {sequenceCards}
                        </Flickity>
                    </div>
                </Col>
            </Row>
        </Container>
    )
}

export default Profile